export enum AddMedicationAdministeredConstants {
  NOT_IMPLEMENTED = 'addMedicationAdministered/NOT_IMPLEMENTED',
  SET_DATE_TIME = 'addMedicationAdministered/SET_DATE_TIME',
  SET_DATE = 'addMedicationAdministered/SET_DATE',
  SET_TIME = 'addMedicationAdministered/SET_TIME',
  SET_ASSESSED_BY = 'addMedicationAdministered/SET_ASSESSED_BY',
  SET_ROLE_PERFORMING = 'addMedicationAdministered/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'addMedicationAdministered/SET_ROLE_PERFORMING_PNNV',
  SET_ADMINISTERED_BY_OTHER_UNIT = 'addMedicationAdministered/SET_ADMINISTERED_BY_OTHER_UNIT',
  SET_ADMINISTERED_BY_OTHER_UNIT_PNNV = 'addMedicationAdministered/SET_ADMINISTERED_BY_OTHER_UNIT_PNNV',
  SET_MEDICATION = 'addMedicationAdministered/SET_MEDICATION',
  SET_DOSE = 'addMedicationAdministered/SET_DOSE',
  SET_DOSE_UNIT = 'addMedicationAdministered/SET_DOSE_UNIT',
  SET_DOSE_UNIT_PNNV = 'addMedicationAdministered/SET_DOSE_UNIT_PNNV',
  SET_RATE = 'addMedicationAdministered/SET_RATE',
  SET_RATE_UNIT = 'addMedicationAdministered/SET_RATE_UNIT',
  SET_FREQUENCY = 'addMedicationAdministered/SET_FREQUENCY',
  SET_ROUTE = 'addMedicationAdministered/SET_ROUTE',
  SET_ROUTE_PNNV = 'addMedicationAdministered/SET_ROUTE_PNNV',
  SET_CONCENTRATION = 'addMedicationAdministered/SET_CONCENTRATION',
  SET_COMPLICATIONS = 'addMedicationAdministered/SET_COMPLICATIONS',
  SET_AUTHORIZATION = 'addMedicationAdministered/SET_AUTHORIZATION',
  SET_WASTED = 'addMedicationAdministered/SET_WASTED',
  SET_LOT_NUMBER = 'addMedicationAdministered/SET_LOT_NUMBER',
  SET_WITNESS_1 = 'addMedicationAdministered/SET_WITNESS_1',
  SET_WITNESS_2 = 'addMedicationAdministered/SET_WITNESS_2',
  DELETE_MEDICATION_ADMINISTERED = 'addMedicationAdministered/DELETE_MEDICATION_ADMINISTERED',
  SAVE_MEDICATION_ADMINISTERED = 'addMedicationAdministered/SAVE_MEDICATION_ADMINISTERED',
  SET_COMMENTS = 'addMedicationAdministered/SET_COMMENTS',
  SET_RESPONSE_VALUE = 'addMedicationAdministered/SET_RESPONSE_VALUE',
  SET_RESPONSE_VALUE_PNNV = 'addMedicationAdministered/SET_RESPONSE_VALUE_PNNV',
  SET_RESPONSE = 'addMedicationAdministered/SET_RESPONSE',
  ADD_MEDICATION_ADMINISTERED = 'addMedicationAdministered/ADD_MEDICATION_ADMINISTERED',
  SET_ADD_MEDICATION_ADMINISTERED_DATA = 'addMedicationAdministered/SET_ADD_MEDICATION_ADMINISTERED_DATA',
  ARE_MEDICATIONS_OPTIONS_LOADING = 'addMedicationAdministered/ARE_MEDICATIONS_OPTIONS_LOADING',
  SET_STATE = 'addMedicationAdministered/SET_STATE',
  RESET_STATE = 'addMedicationAdministered/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'addMedicationAdministered/SET_ADD_TO_TIMELINE',
  ON_SELECT_MEDICATION_ADMINISTERED = 'addMedicationAdministered/ON_SELECT_MEDICATION_ADMINISTERED',
  SET_MEDICATION_ADMINISTERED = 'addMedicationAdministered/SET_MEDICATION_ADMINISTERED',
  SET_CURRENT_MEDICATION = 'addMedicationAdministered/SET_CURRENT_MEDICATION',
  SET_PTA = 'addMedicationAdministered/SET_PTA',
  SET_MEDICATION_DEFAULTS = 'addMedicationAdministered/SET_MEDICATION_DEFAULTS',
}
